import { Box, Modal, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import {
  getAccessControlSettings,
  getInvitedUsersInWorkspaceList,
  getMaxUsersInWorkspace,
} from 'wisestep-api';

import { useSKUModalStore } from '../../../components/skuModal/SKUModalStore';
import { useWorkspaceContext } from '../../../context';
import GlobalLoader from '../../../interceptor/useAxiosLoader';

import InviteForm from './InviteForm';
import InviteLinkForm from './InviteLinkForm';

type PropTypes = {
  open: boolean;
  handleClose: () => void;
  onSuccess?: () => void;
  defaultInvites?: string[];
  pendingUsersLimit?: number;
  roles?: string[];
};

const InviteUserModal = ({
  open,
  handleClose,
  onSuccess,
  defaultInvites = [],
  pendingUsersLimit,
  roles,
}: PropTypes) => {
  const [localState, setLocalState] = useState<{ roles: string[]; pendingUsersLimit: number }>({
    roles: [],
    pendingUsersLimit: 0,
  });
  const setModal = useSKUModalStore((state) => state.setModal);
  const workspaceContext = useWorkspaceContext();
  const [openInvites, setOpenInvites] = useState<boolean>(false);

  useEffect(() => {
    if (!roles) {
      const getRoles = async () => {
        try {
          const accessData = await getAccessControlSettings(workspaceContext?.id ?? '');
          const data = accessData.data;
          const rolesData: string[] = data.map((obj) => obj.workspaceRolesPK.role);
          setLocalState((prev) => ({ ...prev, roles: rolesData }));
        } catch (e) {
          console.log(e);
        }
      };
      getRoles();
    }
    if (!pendingUsersLimit) {
      const getPendingUsersLimit = async () => {
        try {
          const maxInvites = await (
            await getMaxUsersInWorkspace(['RS_MAX_USERS'])
          ).data.RS_MAX_USERS;
          const invitedUsers = await getInvitedUsersInWorkspaceList();
          const activeLength = invitedUsers.data?.filter(
            (invite) => invite.accepted && !invite.barred
          ).length;

          const pendingLimit = maxInvites - activeLength;
          setLocalState((prev) => ({ ...prev, pendingUsersLimit: pendingLimit }));
          setOpenInvites(openInviteModal(maxInvites, pendingLimit));
        } catch (e) {
          console.log(e);
        }
      };
      getPendingUsersLimit();
      const openInviteModal = (maxInvites, pendingLimit) => {
        if (open) {
          if (pendingLimit > 0) return true;
          else {
            setModal({
              object: {
                featureCode: '',
                type: '',
                countType: '',
                consumed: maxInvites - pendingLimit,
                balance: pendingLimit,
                actualLimit: maxInvites,
                message: '',
              },
              type: 'count',
            });
            return false;
          }
        } else return false;
      };
    } else {
      setOpenInvites(open);
    }
  }, [open, pendingUsersLimit, roles, setModal]);

  return (
    <Modal open={openInvites} onClose={handleClose} sx={{ bgcolor: 'transparent' }}>
      <Box px={28}>
        <GlobalLoader />
        <Stack spacing={2} mt={24}>
          <InviteForm
            onSuccess={onSuccess}
            handleClose={handleClose}
            defaultInvites={defaultInvites}
            pendingUsersLimit={pendingUsersLimit ?? localState.pendingUsersLimit}
            rolesFromSettings={roles ?? localState.roles}
          />
          <InviteLinkForm />
        </Stack>
      </Box>
    </Modal>
  );
};

export default InviteUserModal;
